module.exports = __webpack_public_path__ + "img/crest_trans_330px.2e81436c.png";